<article class="incidencia-qa-card" (click)="detallesIncidenciaQA(inc)" (keydown.enter)="detallesIncidenciaQA(inc)">
  <header class="incidencia-qa-card__header">
    <span class="incidencia-qa-card__ticket" [ngStyle]="{ 'background-color': color }">
      {{ inc.id_incidencia_proyecto }}
    </span>

    <div class="incidencia-qa-card__title-block">
      <strong matTooltip="{{ inc.titulo }}" [matTooltipPosition]="'above'">
        {{ inc.titulo.length > 28 ? (inc.titulo | slice : 0 : 28) + '…' : inc.titulo }}
      </strong>
      <span class="incidencia-qa-card__date" matTooltip="{{ inc.fecha_creacion }}" [matTooltipPosition]="'above'">
        <span class="material-icons">date_range</span>
        {{ inc.fecha_creacion }}
      </span>
    </div>
  </header>

  <div class="incidencia-qa-card__badges">
    <span class="incidencia-qa-card__badge incidencia-qa-card__badge--priority" [ngStyle]="{ 'background-color': inc.color }">
      {{ inc.prioridad }}
    </span>

    <span *ngIf="inc.tipo == 'FUNCIONAL'" class="incidencia-qa-card__badge incidencia-qa-card__badge--funcional">
      {{ inc.tipo }}
    </span>

    <span *ngIf="inc.tipo == 'ORTOGRAFICO'" class="incidencia-qa-card__badge incidencia-qa-card__badge--ortografico">
      {{ inc.tipo }}
    </span>
  </div>

  <p class="incidencia-qa-card__description" matTooltip="{{ inc.descincidencia }}" [matTooltipPosition]="'above'">
    {{ inc.descincidencia.length > 72 ? (inc.descincidencia | slice : 0 : 72) + '…' : inc.descincidencia }}
  </p>

  <footer class="incidencia-qa-card__footer">
    <div class="incidencia-qa-card__meta">
      <span
        class="material-icons"
        [ngStyle]="{ color: number(inc.esComentario) ? '#dc2626' : '#64748b' }"
        matTooltip="{{ inc.numero_comentarios }} comentario(s)"
        [matTooltipPosition]="'above'">
        question_answer
      </span>
      <span>{{ inc.numero_comentarios }}</span>
    </div>

    <div class="incidencia-qa-card__meta">
      <span class="material-icons" matTooltip="{{ inc.numero_archivos }} archivos" [matTooltipPosition]="'above'">
        ballot
      </span>
      <span>{{ inc.numero_archivos }}</span>
    </div>
  </footer>
</article>
